import React from 'react';

const UserContext = React.createContext({
  userDetails: {},
  selectedVendor: {
    vendorId: null,
    vendorName: null
  },
  userRole: null,
  isSettingsLoading: false,
  isVendorDropdownVisible: false,
  isVendorDropdownDisabled: false,
  vendorList: []
});
export default UserContext;
